<script module lang="ts">
	export enum ChevronDirection {
		UP = 'UP',
		DOWN = 'DOWN',
		LEFT = 'LEFT',
		RIGHT = 'RIGHT'
	}
</script>

<script lang="ts">
	interface Props {
		width?: string
		defaultFillColor?: string
		highlightColor?: string
		direction?: ChevronDirection
		disabled?: boolean
		onclick?: (() => void) | null
	}

	let {
		width = '2em',
		defaultFillColor = 'black',
		highlightColor = '#007acc',
		direction = ChevronDirection.RIGHT,
		disabled = false,
		onclick = null
	}: Props = $props()

	let currentFillColor: string = $state(defaultFillColor)
	let rotation: string = $state('rotate(0deg)')

	// using this block to reactively trigger the rotation of the svg
	$effect(() => {
		switch (ChevronDirection[direction]) {
			case ChevronDirection.UP:
				rotation = 'rotate(270deg)'
				break
			case ChevronDirection.DOWN:
				rotation = 'rotate(90deg)'
				break
			case ChevronDirection.LEFT:
				rotation = 'rotate(180deg)'
				break
			case ChevronDirection.RIGHT:
				rotation = 'rotate(0deg)'
				break
		}
	})
</script>

<button
	class="chevron-button"
	{disabled}
	onclick={() => {
		if (!disabled) onclick?.()
	}}
	aria-label={direction}
	style="width: {width}; height: {width};"
>
	{#key direction}
		<svg
			{width}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			style="transform: {rotation}; fill: transparent;"
			onmouseover={() => (currentFillColor = highlightColor)}
			onmouseleave={() => (currentFillColor = defaultFillColor)}
		>
			<path
				d="M10 7L15 12L10 17"
				stroke={currentFillColor}
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	{/key}
</button>

<style>
	.chevron-button {
		@apply bg-transparent border-none p-0 cursor-pointer transition ease-in-out;
	}

	.chevron-button:hover {
		background-color: transparent;
	}

	.chevron-button:disabled {
		@apply opacity-10 cursor-not-allowed;
	}
</style>
